import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'
import { getZoneList, getFloorList } from 'features/filter/api'
import { GetZoneListReq, GetFloorListReq } from 'features/filter/types'
import {
  selectConstructType,
  selectZoneList,
  selectUnitList,
  selectFloorList,
} from 'features/filter/selector'
import { Button, Col } from 'antd'
import {
  selectedProjectCodeSelector,
  projectsByIdSelector,
} from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
import { ZoneFilter, ProjectsFilter, FloorFilter } from './Components'
import { selectZoneFilter as selectFilter } from 'features/qc/dashboard/selector'
import { CommonAreaFilter as Filter } from 'features/qc/dashboard/types'
import { updateCommonAreaFilter as updateFilter } from 'features/qc/dashboard/actions'
import { fetchProjects } from 'features/project/project.api'

type Props = {
  onSearch?: () => void
  withPadding?: boolean
} & ReduxProps &
  DispatchProps

const QCZoneFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    zoneList,
    filter,
    onSearch = () => {},
    withPadding = false,
    projectsById,
    floorList,
  } = props

  useEffect(() => {
    dispatch(fetchProjects({ email: UserEmail, token }))
  }, [ProjectCode, UserEmail])

  useEffect(() => {
    filter.ZoneList = []
    filter.FloorList = []
    if (filter.ProjectCode) {
      onGetZoneList()
      onGetFloorList()
    }
  }, [filter.ProjectCode])

  const onGetZoneList = () => {
    const req: GetZoneListReq = {
      ProjectCode: filter.ProjectCode,
      UserEmail,
    }
    dispatch(getZoneList(token, req))
  }

  const onGetFloorList = () => {
    const req: GetFloorListReq = {
      ProjectCode: filter.ProjectCode,
      UserEmail,
    }
    dispatch(getFloorList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    dispatch(updateFilter(filter))
  }

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <div className="filters">
        <Col span={24} className="filters-button">
          <ProjectsFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectsById={projectsById}
          />
          <FloorFilter
            onFilterChange={onFilterChange}
            filter={filter}
            floorList={floorList.List}
          />
          <ZoneFilter
            onFilterChange={onFilterChange}
            filter={filter}
            zoneList={zoneList.List}
          />
          <Button type="primary" onClick={onSearch}>
            กรองข้อมูล
          </Button>
        </Col>
      </div>
    </MainPage>
  )
}

const MainPage = styled.div`
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    constructTypes: selectConstructType(state),
    zoneList: selectZoneList(state),
    unitList: selectUnitList(state),
    projectsById: projectsByIdSelector(state),
    floorList: selectFloorList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(QCZoneFilter)
